import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow
} from '@material-ui/core';
import React, { FC } from 'react';
import FraudReportDownload from '../../../models/TenantReports/MemberWiseReport';
import TableBodyLoader from '../../../shared/components/TableBodyLoader/TableBodyLoader';
import TableFooter from '../../../shared/components/TableFooter/TableFooter';
import TableHeader from '../../../shared/components/TableHeader/TableHeader';
import formatDate from '../../../shared/utils/formatDate';
import Chip from '../../../shared/components/Chip/Chip';
import { GetApp } from '@material-ui/icons';
import { get, isNull } from 'lodash';
import LinearProgressWithLabel from '../Shared/LinearProgressWithLabel';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { downloadReportFile } from '../../../services/TenantReports/common';
import zipDownloadIcon from '../Assets/zip-download.png';

interface FraudReportDownloadTableProps {
  reports: FraudReportDownload[];
  isLoading: boolean;
  page: number;
  offset: number;
  setPage: (page: number) => void;
  setOffset: (offset: number) => void;
}

const headings = [
  'S.No',
  'Date Triggered',
  'Start Date',
  'End Date',
  'Progress',
  'Status',
  'Download'
];

const FraudReportDownloadTable: FC<FraudReportDownloadTableProps> = props => {
  const { reports, isLoading, page, offset, setPage, setOffset } = props;

  const getFileNameForDownload = (report: FraudReportDownload) => {
    const fileType = isCSVFile(report) ? 'csv' : 'zip';
    return `Fraud_Report_${moment().valueOf()}.${fileType}`;
  };

  const getDownloadReportUrl = async (
    report: FraudReportDownload
  ): Promise<any> => {
    const url = report.errorFileLocation;
    console.log(url);
    try {
      if (isNull(url)) {
        return;
      }
      const fileName = getFileNameForDownload(report);
      console.log(fileName);
      await downloadReportFile(url, fileName);
    } catch (e) {
      toast.error('Something went wrong!!!');
    }
  };
  const isCSVFile = (report: FraudReportDownload) => {
    const fileType = get(report, 'data.fileType', 'csv');
    return fileType === 'csv';
  };
  return (
    <TableContainer component={Paper} elevation={0}>
      <Table>
        <TableHeader headings={headings} align="center" />
        {isLoading ? (
          <TableBodyLoader colSpan={headings.length} rowsPerPage={offset} />
        ) : (
          <TableBody>
            {reports.map((report, index) => (
              <TableRow key={report.id}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  {' '}
                  {formatDate(report.createdAt)}{' '}
                </TableCell>
                <TableCell align="center">
                  {' '}
                  {formatDate(report?.data?.date?.startDate)}{' '}
                </TableCell>
                <TableCell align="center">
                  {formatDate(report?.data?.date?.endDate)}
                </TableCell>
                <TableCell align="center">
                  <LinearProgressWithLabel
                    total={report.total}
                    currentValue={report.processedRecords}
                  />
                </TableCell>
                <TableCell align="center">
                  <Chip
                    label={report.status}
                    color={
                      report.status === 'COMPLETED'
                        ? 'success'
                        : report.status === 'FAILED'
                        ? 'error'
                        : 'primary-light'
                    }
                  />
                </TableCell>
                <TableCell align="center">
                  {isCSVFile(report) ? (
                    <IconButton
                      disabled={report.status !== 'COMPLETED'}
                      component="a"
                      onClick={() => getDownloadReportUrl(report)}
                      download
                    >
                      <GetApp />
                    </IconButton>
                  ) : (
                    <Button
                      onClick={() => getDownloadReportUrl(report)}
                      disabled={report.status !== 'COMPLETED'}
                    >
                      <img
                        src={zipDownloadIcon}
                        alt={'download'}
                        style={{
                          width: '3rem',
                          opacity: `${
                            report.status !== 'COMPLETED' ? '50%' : '100%'
                          }`
                        }}
                      />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
        <TableFooter
          colSpan={headings.length}
          count={-1}
          page={page}
          rowsPerPage={offset}
          onPageChange={setPage}
          onRowPerPageChange={setOffset}
        />
      </Table>
    </TableContainer>
  );
};

export default FraudReportDownloadTable;
